import { put, takeLatest, call } from 'redux-saga/effects';
import * as orderService from '../../../services/orderService';
import {
  ADD_ORDER_COMMENT,
  ADD_ORDER_COMMENT_SUCCESS,
  ADD_ORDER_COMMENT_ERROR,
} from '../../actions/order';

function* addOrderCommentSaga(action) {
  try {
    const data = yield call(orderService.AddOrderComment, action.payload);

    yield put({
      type: ADD_ORDER_COMMENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: ADD_ORDER_COMMENT_ERROR,
      error: error.data,
    });
  }
}

export function* addOrderCommentSagaWatcher() {
  yield takeLatest(ADD_ORDER_COMMENT, addOrderCommentSaga);
}
